<template>
  <div style="display: flex;">
    <div style="flex: 1;">
      <a-tabs v-model:activeKey="initState.subTerminalId" size="small">
        <template v-if="initState.terminalId === 1">
          <a-tab-pane :key="1" tab="PC端" />
          <a-tab-pane :key="2" tab="M端" />
        </template>
        <a-tab-pane v-else :key="null" tab="APP端" />
      </a-tabs>
      <a-form-item label="弹窗样式">
        <a-select
          v-model:value="initState.style"
          style="width: 100%;"
          :disabled="!initState.editable"
          @change="onTypeChange"
        >
          <a-select-option
            v-for="item in initState.popupStyleList"
            :key="item.style"
            :value="item.style"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        v-if="image"
        label=" "
        :colon="false"
        style="text-align: center;"
      >
        <img style="max-width: 100%;" :src="image" alt="" />
      </a-form-item>
      <a-form-item label="弹窗类型">
        <a-select placeholder="请选择弹窗类型" v-model:value="initState.type">
          <a-select-option
            v-for="item in initState.popupTypeList"
            :key="item.type"
            :value="item.type"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </div>
    <div style="flex: 1; margin: 0 30px;">
      <a-radio-group
        v-model:value="initState.themeType"
        size="large"
        v-if="initState.style === 8"
      >
        <a-radio-button
          v-for="lang in initState.themeTypes"
          :key="lang.value"
          :value="lang.value"
        >
          {{ lang.label }}
        </a-radio-button>
      </a-radio-group>
      <a-tabs v-model:activeKey="initState.currentLang" size="small">
        <a-tab-pane
          v-for="lang in initState.langList"
          :key="lang.value"
          :tab="lang.label"
        />
      </a-tabs>
      <a-form-item label="标题" v-if="showTitle">
        <a-input
          v-model:value="currentLang.title"
          :maxlength="initState.style === 8 ? 50 : 128"
          placeholder="请输入标题"
        />
      </a-form-item>
      <a-form-item label="标题颜色" v-if="showTitleColor">
        <NColorPicker
          :modes="['hex']"
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.titleColor"
        />
      </a-form-item>
      <a-form-item label="正文文案" v-if="showCopywriting">
        <a-textarea
          v-model:value="currentLang.copywriting"
          :maxlength="copywritingLength"
          placeholder="请输入正文文案"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="图片" v-if="showBigImageSrc">
        <a-upload
          name="file"
          list-type="picture-card"
          :accept="'.png,.jpg,.jpeg,.gif'"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          :customRequest="state.upload"
        >
          <div v-if="currentLang.bigImageSrc" class="img-cover">
            <img
              style="max-width: 100%; max-height: 100%"
              :src="currentLang.bigImageSrc"
              alt="avatar"
            />
            <div class="img-actions">
              <EyeOutlined
                @click.stop="previewImage(currentLang.bigImageSrc)"
              />
              <DeleteOutlined @click.stop="currentLang.bigImageSrc = ''" />
            </div>
          </div>
          <div v-else>
            <PlusOutlined />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
        <template v-if="initState.style === 9">
          <template v-if="currentTerminal.subTerminalId == 1">
            PC端尺寸880*800 @(2X)
          </template>
          <template v-else-if="currentTerminal.subTerminalId == 2">
            M端尺寸622*600 @(2X)
          </template>
          <template v-else>
            APP尺寸622*600 @(2X)
          </template>
        </template>
        <template v-if="initState.style === 11">
          APP尺寸750*440px
        </template>
      </a-form-item>
      <a-form-item label="按钮文案" v-if="showButtonCopywriting">
        <a-input
          v-model:value="currentLang.buttonCopywriting"
          :maxlength="initState.style === 8 ? 20 : 256"
          placeholder="请输入按钮文案"
        />
      </a-form-item>
      <a-form-item
        :label="[11].includes(initState.style) ? '次按钮文案' : '按钮文案'"
        v-if="showButtonText"
      >
        <a-input
          v-model:value="currentLang.buttonText"
          :maxlength="128"
          placeholder="请输入按钮文案"
        />
      </a-form-item>
      <a-form-item label="自动化浮窗类型" v-if="initState.style === 3">
        <a-select
          v-model:value="initState.autoFloatingType"
          @change="onAutoFloatingTypeChange"
        >
          <a-select-option :value="0">落地页链接</a-select-option>
          <a-select-option :value="1">关联奖励</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        v-if="[4, 7, 9].includes(initState.style)"
        :label="initState.style === 9 ? '圣诞弹窗类型' : '自动化弹窗类型'"
      >
        <a-select
          v-model:value="initState.autoPopupType"
          @change="onAutoPopupTypeChange"
          :disabled="initState.style === 7"
          :allow-clear="initState.style === 9"
        >
          <template v-if="initState.style === 9">
            <a-select-option :value="2">复制文案</a-select-option>
          </template>
          <template v-else>
            <a-select-option :value="0">落地页链接</a-select-option>
            <a-select-option :value="1">关联奖励</a-select-option>
            <a-select-option :value="2">复制文案</a-select-option>
          </template>
        </a-select>
      </a-form-item>
      <a-form-item label="复制文案" v-if="showCopyCopywriting">
        <a-input
          v-model:value="currentLang.copyCopywriting"
          placeholder="请输入复制文案"
        />
      </a-form-item>
      <!-- 权益配置 -->
      <div v-if="[11].includes(initState.style)">
        <a-form-item label="Push说明">
          <a-input
            :maxlength="100"
            v-model:value="currentLang.pushDescription"
            placeholder="请输入push说明"
          />
        </a-form-item>
        <BenefitsConfig v-model="currentLang.benefits" />
      </div>
    </div>
    <div style="flex: 1;">
      <a-form-item label="默认币种">
        {{ initState.defaultCurrency }}
      </a-form-item>
      <a-form-item label="关联奖励" v-if="showRelatedRewardsEnable">
        <a-checkbox
          :checked="currentTerminal.relatedRewardsEnable === 1"
          @change="onRelatedRewardsEnableChange"
        />
      </a-form-item>
      <a-form-item
        label="活动事件名称"
        v-if="currentTerminal.relatedRewardsEnable === 1"
      >
        <a-input
          v-model:value="currentTerminal.activityEvent"
          placeholder="请输入活动事件名称"
        />
      </a-form-item>
      <a-form-item label="启用倒计时" v-if="showCountdownEnable">
        <a-checkbox
          :checked="currentTerminal.countdownEnable === 1"
          @change="onCountdownEnableChange"
        />
      </a-form-item>
      <a-form-item
        label="倒计时时长"
        v-if="currentTerminal.countdownEnable === 1"
      >
        <a-input-number
          v-model:value="currentTerminal.countdownDuration"
          placeholder="请输入倒计时时长"
          :min="1"
          :max="600"
          :precision="0"
        />
        <span style="margin-left: 10px;">s</span>
      </a-form-item>
      <a-form-item label="倒计时标题" v-if="showCountdownTitle">
        <a-input
          v-model:value="currentLang.countdownTitle"
          placeholder="请输入倒计时标题"
          :maxlength="128"
        />
      </a-form-item>
      <a-form-item label="倒计时标题颜色" v-if="showCountdownTitleColor">
        <NColorPicker
          :modes="['hex']"
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.countdownTitleColor"
        />
      </a-form-item>
      <a-form-item label="结束时间" v-if="showEndTime">
        <a-date-picker
          show-time
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.endTime"
          placeholder="开始时间"
        />
      </a-form-item>
      <a-form-item label="倒计时背景色" v-if="showCountdownBackgroundColor">
        <NColorPicker
          :modes="['hex']"
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.countdownBackgroundColor"
        />
      </a-form-item>
      <a-form-item label="倒计时字体色" v-if="showCountdownFontColor">
        <NColorPicker
          :modes="['hex']"
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.countdownFontColor"
        />
      </a-form-item>
      <a-form-item label="自动关闭时间" v-if="showAutoCloseDuration">
        <a-input-number
          v-model:value="currentTerminal.autoCloseDuration"
          placeholder="请输入自动关闭时间"
          :min="1"
          :max="initState.style === 7 ? 120 : 11"
          :precision="0"
        />
        <span style="margin-left: 10px;">s</span>
      </a-form-item>
      <a-form-item label="落地页链接" v-if="showLinkUrl">
        <a-input
          v-if="initState.style !== 6"
          v-model:value="currentTerminal.linkUrl"
          placeholder="请输入链接"
        />
        <a-input
          v-else
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.linkUrl"
          placeholder="请输入链接"
        />
      </a-form-item>
      <a-form-item label="按钮跳转链接" v-if="showBtnUrl">
        <a-input
          :disabled="
            initState.currentLang !== initState.defaultLanguageCode ||
              initState.terminalId == 2
          "
          v-model:value="currentTerminal.linkUrl"
          placeholder="请输入链接"
        />
      </a-form-item>
      <a-form-item label="背景色" v-if="showBackgroundColor">
        <NColorPicker
          :modes="['hex']"
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.backgroundColor"
        />
      </a-form-item>
      <a-form-item label="按钮背景色" v-if="showButtonBackgroundColor">
        <NColorPicker
          :modes="['hex']"
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.buttonBackgroundColor"
        />
      </a-form-item>
      <a-form-item label="按钮文案色" v-if="showButtonTextColor">
        <NColorPicker
          :modes="['hex']"
          :disabled="initState.currentLang !== initState.defaultLanguageCode"
          v-model:value="currentTerminal.buttonTextColor"
        />
      </a-form-item>
    </div>
  </div>
  <div style="display: flex; justify-content: flex-end;">
    <a-space>
      <a-button type="primary" @click="next">保存</a-button>
      <a-button @click="initState.prev">上一步</a-button>
    </a-space>
  </div>
</template>

<script setup>
import { computed, inject, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { NColorPicker } from 'naive-ui'
import { material_upload_post } from '@/server/modules/8945'
import { previewImage } from '@/utils/previewImage'
import BenefitsConfig from './BenefitsConfig.vue'
import {
  PlusOutlined,
  DeleteOutlined,
  EyeOutlined
} from '@ant-design/icons-vue'

const state = reactive({
  upload: async info => {
    if (info && info.file) {
      const { data } = await material_upload_post({ file: info.file })
      currentLang.value.bigImageSrc = data.url
    }
  }
})

const images = {
  '0_0': require('assets/img/0.jpg'),
  '0_1': require('assets/img/1.png'),
  '0_3': require('assets/img/m3.png'),
  '0_4': require('assets/img/4.png'),
  '1_2': require('assets/img/pc2.png'),
  '1_3': require('assets/img/3.png'),
  '1_4': require('assets/img/4.png'),
  '1_5': require('assets/img/5.png'),
  '2_2': require('assets/img/m2.png'),
  '2_3': require('assets/img/m3.png'),
  '2_4': require('assets/img/4.png'),
  '2_5': require('assets/img/5.png'),
  '1_6': require('assets/img/6.png'),
  '2_6': require('assets/img/m6.png'),
  '1_7': require('assets/img/7.png'),
  '2_7': require('assets/img/7.png'),
  '0_9': require('assets/img/2_9.png'),
  '1_9': require('assets/img/1_9.png'),
  '2_9': require('assets/img/2_9.png'),
  '0_11': require('assets/img/10.png')
}

const image = computed(() => {
  return images[`${Number(initState.subTerminalId)}_${initState.style}`]
})

const initState = inject('initState')

const currentTerminal = computed(() => {
  return initState.ruleMaterials.find(
    m =>
      m.subTerminalId === initState.subTerminalId &&
      (initState.style !== 8 ||
        !m.themeType ||
        (initState.style === 8 && m.themeType === initState.themeType))
  )
})

const beforeUpload = file => {
  if ([9, 11].includes(initState.style)) {
    return new Promise((resolve, reject) => {
      material_upload_post({ file: file }).then(({ data }) => {
        const Img = new Image()
        Img.src = data.url
        Img.onload = () => {
          const ratio = Img.width / Img.height
          let rule
          if ([11].includes(initState.style)) {
            rule = 750 / 440
          } else if (Number(currentTerminal.value.subTerminalId) === 1) {
            rule = 880 / 800
          } else {
            rule = 622 / 600
          }
          if (ratio === rule) {
            resolve(file)
          } else {
            reject(message.warn('请上传正确比例的图片'))
          }
        }
      })
    })
  }
  if (initState.style !== 8) return true
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = e => {
      const img = new Image()
      img.src = e.target.result
      img.onload = () => {
        // const ratio =
        //   initState.terminalId === 1 && initState.subTerminalId === 1 ? 1 : 1.5
        if (Number((img.width / img.height).toFixed(1)) === 1.5) {
          resolve(file)
        } else {
          reject(message.warn('请选择宽高比例为1.5:1的图片'))
        }
      }
    }
  })
}

const currentLang = computed(() => {
  if (!currentTerminal.value) {
    return null
  }
  return currentTerminal.value.langs.find(
    i => i.langCode === initState.currentLang
  )
})

// 是否需要落地页链接
const showLinkUrl = computed(() => {
  return initState.autoFloatingType === 0 || initState.autoPopupType === 0
})
// 是否需要按钮跳转链接
const showBtnUrl = computed(() => {
  return [8].includes(initState.style)
})

// 是否需要标题
const showTitle = computed(() => {
  return [8, 9, 11].includes(initState.style)
})

// 是否需要标题颜色
const showTitleColor = computed(() => {
  return [9].includes(initState.style)
})

// 是否需要正文文案
const showCopywriting = computed(() => {
  return [0, 1, 3, 4, 5, 7, 8, 11].includes(initState.style) // 活动氛围
})

const copywritingLength = computed(() => {
  if ([11].includes(initState.style)) {
    return 60
  }
  return initState.style === 8 ? 100 : 1000
})
// 是否需要图片
const showBigImageSrc = computed(() => {
  return [0, 2, 3, 4, 6, 8, 9, 11].includes(initState.style)
})

// 是否需要按钮文案
const showButtonCopywriting = computed(() => {
  return [0, 1, 3, 4, 7, 8, 11].includes(initState.style)
})

// 是否需要按钮文案(圣诞弹窗)
const showButtonText = computed(() => {
  return [9, 11].includes(initState.style)
})

// 是否需要复制文案
const showCopyCopywriting = computed(() => {
  return initState.autoPopupType === 2
})

// 是否需要关联奖励
const showRelatedRewardsEnable = computed(() => {
  return initState.autoFloatingType === 1 || initState.autoPopupType === 1
})

// 是否需要启用倒计时
const showCountdownEnable = computed(() => {
  return initState.style === 4
})

// 是否需要背景色
const showBackgroundColor = computed(() => {
  return initState.style === 9
})

// 是否需要按钮背景色
const showButtonBackgroundColor = computed(() => {
  return [9, 11].includes(initState.style)
})

// 是否需要按钮文案背景色
const showButtonTextColor = computed(() => {
  return [9, 11].includes(initState.style)
})

// 是否需要倒计时标题
const showCountdownTitle = computed(() => {
  return initState.style === 9
})

// 是否需要结束时间
const showEndTime = computed(() => {
  return initState.style === 9
})

// 是否需要倒计时标题颜色
const showCountdownTitleColor = computed(() => {
  return initState.style === 9
})

// 是否需要倒计时背景色
const showCountdownBackgroundColor = computed(() => {
  return initState.style === 9
})

// 是否需要倒计时字体色
const showCountdownFontColor = computed(() => {
  return initState.style === 9
})

// 是否需要自动关闭时间
const showAutoCloseDuration = computed(() => {
  return initState.style === 2 || initState.style === 5 || initState.style === 7
})

const onCountdownEnableChange = event => {
  currentTerminal.value.countdownEnable = event.target.checked ? 1 : 0
}

const onRelatedRewardsEnableChange = event => {
  currentTerminal.value.relatedRewardsEnable = event.target.checked ? 1 : 0
}

const onTypeChange = val => {
  if (!currentTerminal?.value) return
  initState.autoFloatingType = null
  initState.autoPopupType = null
  currentTerminal.value.relatedRewardsEnable = null
  currentTerminal.value.activityEvent = null
  currentTerminal.value.countdownEnable = null
  currentTerminal.value.countdownDuration = null
  currentTerminal.value.autoCloseDuration = null
  currentTerminal.value.themeType = val === 8 ? initState.themeType : null
  if (val === 6) {
    initState.autoFloatingType = 0
  }
  if (val === 7) {
    initState.autoPopupType = 2
  }
  initState.createMeterials(val)
}

const onAutoFloatingTypeChange = () => {
  initState.autoPopupType = null
  currentTerminal.value.relatedRewardsEnable = null
  currentTerminal.value.activityEvent = null
  currentTerminal.value.countdownEnable = null
  currentTerminal.value.countdownDuration = null
  currentTerminal.value.autoCloseDuration = null
}

const onAutoPopupTypeChange = () => {
  initState.autoFloatingType = null
  currentTerminal.value.relatedRewardsEnable = null
  currentTerminal.value.activityEvent = null
  currentTerminal.value.countdownEnable = null
  currentTerminal.value.countdownDuration = null
  currentTerminal.value.autoCloseDuration = null
}

const validateBenefits = lang => {
  if (initState.style !== 11) return true

  const benefits = lang.benefits || []
  const langLabel =
    initState.langList.find(l => l.value === lang.langCode)?.label ||
    lang.langCode

  if (benefits.length < 2) {
    message.warn(`【${langLabel}】权益配置至少需要保留 2 条`)
    return false
  }

  for (let i = 0; i < benefits.length; i++) {
    if (!benefits[i].iconSrc) {
      message.warn(`【${langLabel}】第 ${i + 1} 条权益未上传图标`)
      return false
    }
    if (!benefits[i].benefitText || !benefits[i].benefitText.trim()) {
      message.warn(`【${langLabel}】第 ${i + 1} 条权益未填写文案`)
      return false
    }
  }

  return true
}

const next = async () => {
  if (initState.style === null) {
    return message.warn('请选择弹窗样式')
  }
  if (initState.type === null) {
    return message.warn('请选择弹窗类型')
  }
  if (initState.style === 9 && !initState.autoPopupType) {
    return message.warn('请选择圣诞弹窗类型')
  }

  for (const terminal of initState.ruleMaterials) {
    if (showLinkUrl.value && !terminal.linkUrl) {
      return message.warn('请输入落地页链接')
    }
    if (showBtnUrl.value && !terminal.linkUrl && initState.terminalId !== 2) {
      return message.warn('请输入按钮跳转链接链接')
    }
    if (terminal.relatedRewardsEnable === 1 && !terminal.activityEvent) {
      return message.warn('请输入活动事件名称')
    }
    if (terminal.countdownEnable === 1 && !terminal.countdownDuration) {
      return message.warn('请输入倒计时时间')
    }
    if (showAutoCloseDuration.value && !terminal.autoCloseDuration) {
      return message.warn('请输入自动关闭时间')
    }
    if (
      (initState.autoFloatingType === 1 || initState.autoPopupType === 1) &&
      terminal.relatedRewardsEnable !== 1
    ) {
      return message.warn('请勾选关联奖励')
    }
    if (showBackgroundColor.value && !terminal.backgroundColor) {
      return message.warn('请输入背景色')
    }
    if (showButtonBackgroundColor.value && !terminal.buttonBackgroundColor) {
      return message.warn('请输入按钮背景色')
    }
    if (showButtonTextColor.value && !terminal.buttonTextColor) {
      return message.warn('请输入按钮文案背景色')
    }
    if (showEndTime.value && !terminal.endTime) {
      return message.warn('请输入结束时间')
    }
    if (showCountdownTitleColor.value && !terminal.countdownTitleColor) {
      return message.warn('请输入倒计时标题颜色')
    }
    if (
      showCountdownBackgroundColor.value &&
      !terminal.countdownBackgroundColor
    ) {
      return message.warn('请输入倒计时背景色')
    }
    if (showCountdownFontColor.value && !terminal.countdownFontColor) {
      return message.warn('请输入倒计时字体色')
    }
    for (const lang of terminal.langs) {
      const langLabel =
        initState.langList.find(l => l.value === lang.langCode)?.label ||
        lang.langCode
      if (showTitle.value && !lang.title) {
        return message.warn('请输入标题')
      }
      if (showCopywriting.value && !lang.copywriting) {
        return message.warn('请输入正文文案')
      }
      if (showBigImageSrc.value && !lang.bigImageSrc) {
        return message.warn('请上传图片')
      }
      if (showButtonCopywriting.value && !lang.buttonCopywriting) {
        return message.warn('请输入按钮文案')
      }
      if (
        showCopyCopywriting.value &&
        !lang.copyCopywriting &&
        initState.style !== 7
      ) {
        return message.warn('请输入复制文案')
      }
      if (showCountdownTitle.value && !lang.countdownTitle) {
        return message.warn('请输入倒计时标题')
      }
      if (showButtonText.value && !lang.buttonText) {
        return message.warn('请输入按钮文案')
      }
      if (+initState.style === 11 && !lang.pushDescription) {
        return message.warn(`【${langLabel}】请输入push说明`)
      }
      // 权益配置校验（多语言独立校验）
      if (!validateBenefits(lang)) {
        return
      }
    }
  }
  initState.next()
}
</script>

<style lang="scss" scoped>
.img-cover {
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
  .img-actions {
    cursor: pointer;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;

    &:hover {
      opacity: 1;
    }

    .anticon {
      margin: 0 8px;
    }
  }
}
</style>
